module.exports = __webpack_public_path__ + "img/feature2-1x.9a7e133.png";